var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "#3C3C3B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97468 1.47472C2.96657 0.482839 4.40362 0.0416641 6.16663 0.0416641H12.8333C14.5963 0.0416641 16.0334 0.482839 17.0252 1.47472C18.0171 2.46661 18.4583 3.90366 18.4583 5.66666V12.3333C18.4583 14.0963 18.0171 15.5334 17.0252 16.5253C16.0334 17.5172 14.5963 17.9583 12.8333 17.9583H1.99996C1.19645 17.9583 0.541626 17.3035 0.541626 16.5V5.66666C0.541626 3.90366 0.982801 2.46661 1.97468 1.47472ZM2.85857 2.35861C2.18378 3.03339 1.79163 4.09634 1.79163 5.66666V16.5C1.79163 16.6132 1.8868 16.7083 1.99996 16.7083H12.8333C14.4036 16.7083 15.4666 16.3162 16.1414 15.6414C16.8161 14.9666 17.2083 13.9037 17.2083 12.3333V5.66666C17.2083 4.09634 16.8161 3.03339 16.1414 2.35861C15.4666 1.68382 14.4036 1.29166 12.8333 1.29166H6.16663C4.5963 1.29166 3.53335 1.68382 2.85857 2.35861Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70825 6.91666C4.70825 6.57149 4.98807 6.29166 5.33325 6.29166H13.6666C14.0118 6.29166 14.2916 6.57149 14.2916 6.91666C14.2916 7.26184 14.0118 7.54166 13.6666 7.54166H5.33325C4.98807 7.54166 4.70825 7.26184 4.70825 6.91666Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70825 11.0833C4.70825 10.7382 4.98807 10.4583 5.33325 10.4583H11.1666C11.5118 10.4583 11.7916 10.7382 11.7916 11.0833C11.7916 11.4285 11.5118 11.7083 11.1666 11.7083H5.33325C4.98807 11.7083 4.70825 11.4285 4.70825 11.0833Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.3b65f9bd86935f4a74b82c10160d6aa0.svg";
export { ForwardRef as ReactComponent };